import React from "react";
import PageTemplate from "../components/PageTemplate";
import AdvancedSettingsHeaderMobile from "../components/targeting/TargetingHeaderMobile";
import TargetingBody from "../components/targeting/TargetingBody";

const Targeting = () => {
  return (
    <PageTemplate
      title="Advanced Options"
      mobileHeader={<AdvancedSettingsHeaderMobile/>}
      sidebarTitle="Bullseye 🎯"
      sidebarSubtitle="Target vistors based on page URLS, UTMs, etc."
      centered
      fullWidth
    >
      <TargetingBody/>
    </PageTemplate>
  );
};

export default Targeting;
